import { Language } from '../../types/graphics';

export const LANGUAGES = [
  {
    text: 'All',
    value: Language.ALL,
  },
  {
    text: 'English',
    value: Language.ENGLISH,
  },
  {
    text: 'Japanese',
    value: Language.JAPANESE,
  },
];
